module.exports = __webpack_public_path__ + "static/media/illu_profil.432dc529.svg";